import { useNavigate } from 'react-router-dom';
import { useConvexAuth } from 'convex/react';
import { MainRoutes } from '../../shared/models';
import { useLoadingWrapper } from '../../shared/hooks/useLoadingWrapper';
import { useState, useEffect } from 'react';
import { useStableQuery } from '../../shared/hooks/useStableQuery';
import { api } from '../../convex/_generated/api';
import { TraitBadge } from '../progress/components/TraitBadge';
import { FAQHelpIcon } from '../../shared/components/FAQHelpIcon';
import { useTranslation } from 'react-i18next';
import { Button } from '../../catalyst-components/button';

export const Skills = () => {
  const [isLoading, setIsLoading] = useState(true);
  const { t } = useTranslation();
  const { isAuthenticated } = useConvexAuth();
  const navigate = useNavigate();
  const traits = useStableQuery(api.skills.list);
  const LoadingWrapper = useLoadingWrapper({ isLoading });

  if (!isAuthenticated) {
    navigate(MainRoutes.Landing);
  }

  useEffect(() => {
    if (traits !== undefined) {
      setIsLoading(false);
    }
  }, [traits]);

  return (
    <LoadingWrapper>
      <section className="min-h-screen bg-background pt-24">
        {/* Header Section */}
        <div className="px-6 pt-8 pb-8 text-center bg-gradient-to-r from-primary/5 to-accent/5">
          <div className="max-w-2xl mx-auto text-left">
            <Button
              color="light"
              onClick={() => navigate(MainRoutes.Progress)}
              className="mb-4"
            >
              {t('common.backHome')}
            </Button>
          </div>
          <div className="max-w-2xl mx-auto animate-fade-in">
            <h1 className="text-4xl font-semibold text-foreground mb-4">
              My Skills
            </h1>
            <p className="text-xl text-muted-foreground">
              {t('skill.description')}
            </p>
            <div className="mt-3">
              <FAQHelpIcon anchor="progress" size="md" tooltipText="Learn about the 5 skills" />
            </div>
          </div>
        </div>

        {/* Skill Cards */}
        <section className="px-6 pb-24">
          <div className="max-w-2xl mx-auto mt-8 space-y-4">
            {traits?.map((trait) => (
              <TraitBadge
                key={trait._id}
                trait={trait.name}
                id={trait._id}
                shortDescription={trait.short_description || ''}
              />
            ))}
          </div>
        </section>
      </section>
    </LoadingWrapper>
  );
};
